'use strict';

var _ = require('lodash');

var DEFAULT_OPTIONS = {
  metric: true
};

function ElevationRenderer (map, template, options) {
  this._map = map;
  this._options = _.extend(DEFAULT_OPTIONS, options);
  this._template = template;
  
  this._createElement();
}

ElevationRenderer.prototype = {

  getElement: function () {
    return this._element;
  },

  _createElement: function () {
    this._element = angular.element(this._template);
  },

  updateElevation: function (elv) {
    
    if (elv === undefined || elv === null) {
      return;
    }

    var text = elv.toFixed(2);
    var elvEl = this._element.eq(1);
    var text = this._options.metric && text + 'm' || text + 'ft';
    elvEl.text(text);
  }
};

module.exports = ElevationRenderer;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/controls/lib/ElevationRenderer.js